<template>

    <div id="g-recaptcha" class="g-recaptcha" :data-sitekey="sitekey"></div>

</template>


<script>

    import { config } from '../config';

    export default {

        name: 'Recaptcha',

        data() {
            return {
                sitekey: config.recaptchaSitekey,
                badge: 'inline', // bottomright, bottomleft, inline
                widgetId: 0
            }
        },

        mounted() {

            if (typeof window.grecaptcha === 'undefined') {
                let script = document.createElement('script');
                script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
                script.onload = this.renderWait;
                document.head.appendChild(script);
            } else {
                this.render();
            }

        },

        methods: {

            renderWait() {

                setTimeout(() => {
                    if (typeof window.grecaptcha !== 'undefined' && typeof window.grecaptcha.render !== 'undefined') {
                        this.render();
                    } else {
                        this.renderWait();
                    }
                }, 200);

            },

            execute() {
                window.grecaptcha.execute(this.widgetId);
            },

            reset() {
                window.grecaptcha.reset(this.widgetId);
            },

            render() {
                if (window.grecaptcha) {
                    this.widgetId = window.grecaptcha.render('g-recaptcha', {
                        jsUrl: 'https://www.google.com/recaptcha/api.js?render=explicit',
                        sitekey: this.sitekey,
                        badge: this.badge,
                        size: 'invisible',
                        callback: (res) => {
                            this.$emit('verify', res);
                            this.reset();
                        }
                    });
                }
            }

        }

    }

</script>

<style lang="scss" scoped>

    .g-recaptcha {
        position: relative;
        z-index: 9999;
    }

</style>
